import { NavButton } from 'Components/ClientApp/CombinedApp/Navigation/NavButton';
import { buildPageLink } from 'Views/Page/Content/Templates';
import fr from 'facet-rest';
import { clientPaths } from 'Consts/Strings';
import React from 'react';
import useMobile from 'Hooks/useMobileLayout';
import useUserContext from 'Context/UserContext';
import useMessagesStatsContext from 'Context/MessagesStatsContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';

export const MessagesNavButton = () => {
  const { userResource, isAgent } = useUserContext();
  const isMobile = useMobile();
  const { unreadThreadCount } = useMessagesStatsContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const onMessagesClick = () => {
    if (!isAgent) {
      logStandardizedEvent(categories.clientMessages,
        eventTypes.navigateTo,
        `Messages -  Navigated to Messages via New Nav on ${isMobile ? 'mobile' : 'desktop'}`);
    }
  };

  return userResource.withRelationship(
    fr.relationships.messagesPage.name,
    () => (
      <NavButton
        value="messages"
        to={buildPageLink(userResource.relationship(fr.relationships.messagesPage.name).link('related'), clientPaths.messagesPage)}
        onClick={() => onMessagesClick()}
        label="Messages"
        badge={unreadThreadCount === 0 ? undefined : {
          test: 'nav-messages-unread-badge',
          content: unreadThreadCount,
        }}
      />
    ),
    () => null,
  );
};
